import React from "react";

export default function TableControls({ 
  sortField, 
  sortDirection, 
  setSortField, 
  setSortDirection, 
  membersPerPage, 
  setMembersPerPage,
  totalItems,
  theme
}) {
  return (
    <div className={`flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-4 p-3 rounded-md ${
      theme === 'dark' ? 'bg-gray-800 text-gray-200' : 'bg-blue-100 text-gray-900'
    }`}>
      {/* Sort Controls */}
      <div className="flex flex-col xs:flex-row xs:items-center gap-2 flex-wrap">
        <label className="font-medium text-sm whitespace-nowrap">Sort by:</label>
        <div className="flex gap-2 flex-wrap">
          <select
            value={sortField}
            onChange={(e) => setSortField(e.target.value)}
            className={`p-2 border rounded text-sm ${
              theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-gray-900 border-gray-300'
            }`}
          >
            <option value="name">Name</option>
            <option value="email">Email</option>
            <option value="status">Status</option>
            <option value="classesRemaining">Classes Remaining</option>
            <option value="membershipEndDate">End Date</option>
          </select>

          <select
            value={sortDirection}
            onChange={(e) => setSortDirection(e.target.value)}
            className={`p-2 border rounded text-sm ${
              theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-gray-900 border-gray-300'
            }`}
          >
            <option value="asc">⬆ Ascending</option>
            <option value="desc">⬇ Descending</option>
          </select>
        </div>
      </div>

      {/* Rows per page Dropdown */}
      <div className="flex flex-col xs:flex-row xs:items-center gap-2">
        <label className="font-medium text-sm whitespace-nowrap">Rows per page:</label>
        <div className="flex items-center gap-2">
          <select
            value={membersPerPage}
            onChange={(e) => setMembersPerPage(Number(e.target.value))}
            className={`p-2 border rounded text-sm ${
              theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-gray-900 border-gray-300'
            }`}
          >
            {[5, 7, 10, 25, 50].map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
          <span className={`text-xs sm:text-sm whitespace-nowrap ${
            theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
          }`}>
            {totalItems} records
          </span>
        </div>
      </div>
    </div>
  );
}
